export const SCHOOLS = {
    C: 'Conjuration',
    A: 'Abjuration',
    N: 'Necromancy',
    V: 'Evocation',
    T: 'Transmutation',
    E: 'Enchantment',
    D: 'Diviniation',
    I: 'Illusion'
};